define('auth',[
  'underscore',
  'utils/uri_helper',
  'utils/constants',
  'utils/wrapper',
  'sdk/api',
  'runtime',
  'dialog',
  'sdk/ui',
  'event',
  'analytics',
  'utils/domain',
  ],
  function(
    _,
    UriHelper,
    CONST,
    __w,
    API,
    Runtime,
    Dialog,
    UI,
    Event,
    Analytics,
    Domain) {
  var tryRedirectWithAuthResponse = function(resp) {
    var redirectUri;
    if (!resp) {
      return null;
    }
    try {
      redirectUri = resp.authResponse.redirect_uri;
      if (redirectUri) {
        document.location.href = redirectUri;
      }
    }
    catch(e) {
      if (typeof console != 'undefined' && typeof console.log != 'undefined') {
        console.log(e);
      }
    }
    return null;
  };
  var executeFnAndCallback = function(fn, cb, path) {
    return function(r) {
      var d = fn(r);
      var _cb = __w(cb);

      if (d && d.authResponse && d.authResponse.event_action == 'register') {
        Analytics.tracker({
          event: 'reg',
          game_id: Runtime.__options.appId,
          domain: Domain.getDomain()
        });
      }

      if (_.isFunction(_cb) && _cb.hasCallback) {
        return _cb(d);
      } else {
        tryRedirectWithAuthResponse(d);
      }
    };
  };
  var Auth = {
    login_or_register: function(path, options, success, error) {

      path = CONST.root_url + '/widgets/' + (path || 'login');
      options = options || {};

      var meta;
      var query;

      // Metadata are sent in prefill namespace
      meta = _.clone(Runtime.getDefaultMeta());
      meta = _.extend(meta, options.meta || {});
      meta = { prefill: meta };
      query = {
        client_id: Runtime.getAppId(),
        redirect_uri: Runtime.getRedirectUri(options.redirect_uri),
        response_type: options.response_type || Runtime.getDefaultResponseType()
      };
      query = _.extend(query, meta);
      query.scope = options.scope || '';
      if (options.state) {
        query.state = options.state;
      }

      var dialog = UI.createIframeDialog(
          __w(executeFnAndCallback(this.storeLoginResponse, success, path)),
          error, path, query);
      return dialog;
    },
    login: function(options, success, error) {
      return Auth.login_or_register('login', options, success, error);
    },
    register: function(options, success, error) {
      return Auth.login_or_register('register', options, success, error);
    },
    storeLoginResponse: function(resp) {
      if (resp) {
        resp.status = resp.result;
        Runtime.setStatus(resp.status);
        delete resp.result;
        Runtime.setAuthResponse(resp.authResponse);
        Event.fire('auth.authResponseChange', resp);
      }
      return resp;
    },
    fetchLoginStatus: function(success, error, options) {
      options = options || {};
      success = success || function() {};
      error = error || function() {};
      var url = CONST.root_url + '/oauth/status';
      var xdHandler = API.getXdHandler();
      xdHandler.api({
        method: 'GET',
        url: url,
        data: {
          redirect_uri: options.redirect_uri || Runtime.getRedirectUri(),
          _sdk: 1,
          response_type: options.response_type || Runtime.getDefaultResponseType(),
          client_id: Runtime.getAppId()
        }
      },
      __w(executeFnAndCallback(
          this.storeLoginResponse, success, 'login', false)),
      __w(error));
    }
  };
  return Auth;
});

